import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import GamesNavbar from "../components/GamesNavbar";
import { createDemoRoom, getDemoTemplate } from "../../services/JubenshaService";
import "./CreateJubenshaRoom.css";

export default function CreateJubenshaRoom() {
  const history = useHistory();
  const [roomName, setRoomName] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const [template, setTemplate] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(true);
  const [showBackground, setShowBackground] = useState(false);

  useEffect(() => {
    const loadTemplate = async () => {
      try {
        const data = await getDemoTemplate();
        setTemplate(data);
      } catch (err) {
        console.error("Failed to load template", err);
      } finally {
        setLoadingTemplate(false);
      }
    };

    loadTemplate();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!template) return;

    if (!roomName.trim() && !template.title) {
      alert("Please enter a room name");
      return;
    }

    setIsCreating(true);

    try {
      const room = await createDemoRoom({
        name: roomName.trim() || template.title,
      });
      history.push(`${process.env.PUBLIC_URL}/games/jubensha/${room.id}`);
    } catch (error) {
      console.error("Failed to create room", error);
      alert("Failed to create room. Please try again.");
      setIsCreating(false);
    }
  };

  return (
    <div className="create-jubensha-room">
      <GamesNavbar />
      <div className="create-room-content">
        <div className="room-form-container">
          {loadingTemplate ? (
            <div className="template-loading">Loading template...</div>
          ) : (
            <div className="template-preview">
              <div className="template-header">
                <div>
                  <div className="template-name">{template?.title}</div>
                  <div className="template-meta">
                    {template?.setting?.location} · {template?.setting?.vibe}
                  </div>
                </div>
                <div className="template-pill">{template?.characters?.length || 0} roles</div>
              </div>
              {template?.backgroundStory && (
                <div className="template-background">
                  <div className={`template-background-text ${showBackground ? "expanded" : ""}`}>
                    {template.backgroundStory}
                  </div>
                  <button
                    type="button"
                    className="template-background-toggle"
                    onClick={() => setShowBackground((v) => !v)}
                  >
                    {showBackground ? "Hide background" : "Show background"}
                  </button>
                </div>
              )}
              <div className="character-preview-grid">
                {(template?.characters || []).map((character) => (
                  <div key={character.id} className="character-card">
                    <div className="character-card-head">
                      <img
                        className="character-icon"
                        src={character.iconUrl || "https://placehold.co/128x128?text=ROLE"}
                        alt={character.name}
                      />
                      <div>
                        <div className="character-name">{character.name}</div>
                        <div className="character-role">{character.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="room-form">
            <div className="form-group">
              <label className="form-label">Room Name</label>
              <input
                type="text"
                className="form-input"
                value={roomName}
                onChange={(e) => setRoomName(e.target.value)}
                placeholder={template?.title || "Enter room name..."}
                maxLength={60}
                disabled={isCreating}
              />
            </div>

            <button
              type="submit"
              className="btn-create-room"
              disabled={isCreating || loadingTemplate}
            >
              {isCreating ? "Creating..." : "Create Room"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
